import {Grid} from "@material-ui/core";
// import headerBg from "../images/intro.jpg";
// import headerStripe from "../images/banda.png";
// import bgStripe from "../images/forma.png";
import homepageSite from '../images/HOMEPAGE-SITE__cremosso 1.jpg'
import {makeStyles} from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    backgroundVisual: {
        width: '100%',
        //height: '100%',
        display: 'inline-block',
        margin: 0,
        [theme.breakpoints.only("xs")]: {
            height: 'auto'
        }
    },
    stripeImg: {
        width: '100%',
        display: 'inline-block',
        marginTop: '-11rem',
        position: 'relative',
        //top:'.7rem',
        //marginBottom:'.2rem',
        [theme.breakpoints.only("xs")]: {
            height: 'auto',
            //position: 'absolute',
            //left:0,
            //marginTop:'8rem'
            top: '-0.15rem'

        },
        [theme.breakpoints.only("sm")]: {
            // marginBottom: '.75rem',
            top: '-0.15rem'
        },
    },
    bg_stripeImg: {
        width: '100%',
        display: 'inline-block',
        marginTop: '-8vw',
        marginBottom: '1rem',

        [theme.breakpoints.only("xs")]: {
            height: 'auto',
            //position: 'absolute',
            //left:0,
            //marginTop:'8rem'
            marginBottom: '.0em',
            marginTop: '-7rem',
        },
        [theme.breakpoints.only("sm")]: {
            marginBottom: '.0em',
            marginTop: '-7rem',
            // marginBottom: '2rem'
        },

    },

    shadow_blue: {
        position: 'absolute',
        top: 0,

    },
    inscriereSection: {
        position: 'absolute',
        right: '50%',
        left: '50%',
        top: '84%',
        zIndex: 2,
        transform: 'translate(-50%,-50%)',
        textAlign: 'center',
        color: '#fff !important',
        width: '20rem',
        '& button': {
            width: "100%",
        },
        [theme.breakpoints.only("xs")]: {
            //paddingTop: '20px',
            position: 'relative',
            //background: `transparent url('/static/images/bg_mob.jpg') no-repeat center center / 100% 100%`,
            //backgroundColor: '#141E80',//theme.palette.background.default,
            right: 'auto',
            left: 'auto',
            top: '-2%',
            margin: '0 auto',
            //borderRadius: '0 0 50% 50%',
            paddingBottom: '7%',
            width: '100%',
            transform: 'initial',
            marginTop: '-1rem'
        },
        [theme.breakpoints.only("sm")]: {
            top: '60%'
        },
        [theme.breakpoints.between("md", "lg")]: {
            top: '75%'
        },


    }

}))

function Home(props: any = {}) {


    let classes: any = useStyles();

    // const noop = () => {
    // };
    //
    // let refTriggers = props.refTriggers || {};
    // let refInscriere = refTriggers.hasOwnProperty('inscriere') && typeof refTriggers.inscriere === "function" ? refTriggers.inscriere : noop;
    return <Grid ref={props.forwardRef || null} container style={{position: "relative"}}>
        <Grid item xs={12}
              style={{fontSize: 0}}
        >
            <img src ={homepageSite} alt={'cremosso-homepage'} className={classes.backgroundVisual} />
            {/*<img src={headerBg} className={classes.backgroundVisual} alt={''}/>*/}
            {/*<img src={headerStripe} className={classes.stripeImg} alt={''}/>*/}
            {/*<img src={bgStripe} className={classes.bg_stripeImg} alt={''}/>*/}
        </Grid>
    </Grid>

}

export default Home;
